import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Choices,
  CountryField,
  DocumentsToProvide,
  FORMALITY_COUNTRIES,
  FormalityPage,
  TextField,
  fieldError,
} from "../../../components/formalities/FormalityParts";
import { showError } from "../../../components/options/OptionParts";
import { addToCart } from "../../../redux/actions/CartActions";
import { createTrademarkRequest } from "../../../redux/actions/FormalityActions";

const TRADEMARK_PRICE = 750000;

// OAPI trademark protection, for a person or a company
function Trademark() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);

  const [country, setCountry] = useState(FORMALITY_COUNTRIES[0]);
  const [holderType, setHolderType] = useState("person");
  const [brandName, setBrandName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const forCompany = holderType === "company";
  const errors = {
    brandName: fieldError(brandName),
    businessName: forCompany ? fieldError(businessName) : null,
  };
  const isValid = country && !errors.brandName && !errors.businessName;

  const handleCreated = async ({ success, message }) => {
    if (!success) {
      setSubmitting(false);
      showError(Swal, message);
      return;
    }

    await dispatch(addToCart({ from: "trademark", price: TRADEMARK_PRICE }));
    setSubmitting(false);
    navigate("/formality-documents");
  };

  const handleContinue = () => {
    setTouched(true);
    if (!isValid) return;

    setSubmitting(true);
    dispatch(
      createTrademarkRequest(
        user.token,
        {
          country,
          holderType,
          brandName: brandName.trim(),
          ...(forCompany ? { businessName: businessName.trim() } : {}),
        },
        handleCreated,
      ),
    );
  };

  return (
    <FormalityPage
      from="trademark"
      title="Protection de la marque à l'OAPI"
      lead="Déposez votre marque à l'OAPI pour une classe de produits ou de services."
      price={TRADEMARK_PRICE}
      submitting={submitting}
      onContinue={handleContinue}
    >
      <CountryField value={country} onChange={setCountry} />

      <Choices
        label="Qui sera le titulaire de la marque ?"
        options={[
          { value: "person", label: "Personne physique" },
          { value: "company", label: "Entreprise" },
        ]}
        value={holderType}
        onChange={setHolderType}
      />

      <TextField
        id="trademark-name"
        label="Nom de la marque"
        placeholder="Ex. : Kribi Digital"
        value={brandName}
        onChange={setBrandName}
        error={touched ? errors.brandName : null}
      />

      {forCompany && (
        <TextField
          id="trademark-company"
          label="Nom de l'entreprise"
          value={businessName}
          onChange={setBusinessName}
          error={touched ? errors.businessName : null}
        />
      )}

      <DocumentsToProvide
        documents={["Pièce d'identité", "Logo à protéger"]}
        hint="Pour une protection plus forte, faites figurer le nom de la marque sur le logo."
      />
    </FormalityPage>
  );
}

export default Trademark;
